import { map, find, prop, pipe, eqProps, innerJoin } from 'ramda'
import { makeObj } from '@/vue/util/briqRamdaExt.js'

export const mergeIntegrationFields = (defaultIntegrationFields, existingIntegrationFields) =>
  map(generatedIntegrationField => {
    const existing = find(eqProps('IntegrationCode', generatedIntegrationField))(
      existingIntegrationFields,
    )
    return existing ? existing : generatedIntegrationField
  })(defaultIntegrationFields)

export const mapCustomFieldsByDefinition = map(
  makeObj({
    FieldCode: prop('FieldCode'),
    DisplayName: prop('FieldName'),
    Datatype: prop('Datatype'),
    Values: () => [],
  }),
)

export const generateIntegrationFieldsByDefinitions = map(
  makeObj({
    IntegrationCode: prop('IntegrationCode'),
    DisplayName: prop('IntegrationDisplayName'),
    Fields: pipe(prop('FieldDefinitions'), mapCustomFieldsByDefinition),
  }),
)
